import * as R from 'ramda'

import { builtinEffects as editEffects } from 'coact/saga/editSaga'

import issueInvoice from './issueInvoice.js'

function shouldPrint(invoice) {
  const hasBuyer = R.path(['buyer', 'id'], invoice).length === 8
  const hasCarrier = !!R.path(['carrier', 'type'], invoice)
  const hasDonation = !!R.path(['donation'], invoice)

  if (hasBuyer) return true

  if (hasCarrier || hasDonation) return false

  return true
}

export default function* saveAndPrintInvoice(payload, ctx) {
  const { skipInvoice = false } = payload || {}

  // save and return invoice data
  const savedData = yield ctx.S.call(editEffects.save)

  if (savedData) {
    // The staff was told the invoice service is unavailable and chose to carry
    // on, so the order is recorded and nothing is issued or printed. Checking
    // out the same order again once the service is back issues the invoice.
    if (skipInvoice) {
      ctx.history.push('/edit/retailOrders/view/eventCashier')

      return
    }

    yield ctx.S.delay(1000)
    const res = yield ctx.S.call(issueInvoice, savedData)
    const { invoice } = res
    if (shouldPrint(invoice)) {
      ctx.resetPath({ path: ['invoiceOfPrinting'], value: invoice })
      yield ctx.S.delay(1000)

      window.print()
    }

    // Go To Next One
    ctx.history.push('/edit/retailOrders/view/eventCashier')
  }
}
